import { Component, OnInit } from '@angular/core';
import { ArticleService, IArticle } from '../shared/services/article.service';
import { ICategoryListItem, IEvent } from '../shared/services/event.service';
import * as moment from 'moment';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  searchSelected = false;
  articles: Array<IArticle>;
  events: Array<IEvent>;
  categories: Array<ICategoryListItem>;
  serverUrl = environment.serverUrl;
  searchTerm;

  constructor(private articleService: ArticleService,
              private router: Router) {
  }

  ngOnInit() {
    this.getHomepageInformation();
  }

  async getHomepageInformation() {
    const homepageInformation = await this.articleService.getHomepageInformation();
    this.events = homepageInformation.data.events;
    this.articles = homepageInformation.data.articles;
    this.categories = homepageInformation.data.categories;
  }

  onSearch() {
    this.router.navigate(['iskalnik'], {
      queryParams: {
        term: this.searchTerm
      }
    });
  }

  onCategory(category) {

    console.log('Category');

    this.router.navigate(['iskalnik'], {
      queryParams: {
        kategorija: category.name,
        id: category._id
      }
    });
  }

  onSearchFocus() {
    this.searchSelected = true;
  }

  onSearchKeyUp() {
    this.searchSelected = false;
  }

  onSearchBlur() {
    this.searchSelected = false;
  }

  onSearchLeave() {
    this.searchSelected = false;
  }

  getArticleTextString(event: IArticle) {

    if (!event.text) {
      return;
    }

    if (event.text.length < 150) {
      return this.stripHtml(event.text);
    }
    return this.stripHtml(event.text).substr(0, 150) + '...';
  }

  getEventTextString(event: IEvent) {

    if (!event.text) {
      return;
    }

    if (event.text.length < 150) {
      return this.stripHtml(event.text);
    }
    return this.stripHtml(event.text).substr(0, 150) + '...';
  }

  stripHtml(html) {
    const tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }

  formatDate(date) {
    return moment(date).format('DD/MM/YYYY');
  }

  formatDateAndTime(date) {
    return moment(date).format('DD/MM/YYYY ob HH:mm');
  }

}
